import React, { useEffect, useState } from 'react'
import { useFormik } from "formik"
import Select from "react-select";
import * as Yup from "yup"
import { Button, Col, Form, FormFeedback, FormGroup, Input, Label, Modal, ModalBody, ModalHeader, Row } from 'reactstrap'
import useApi from 'common/ApiMiddlewere'
import toast from 'react-hot-toast'
import Flatpickr from "react-flatpickr";
import { dateFormat, formatDateToISO } from 'pages/Common';

const colourStyles = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid  #ced4da",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}

const colourStyles1 = {
    option: (styles, { isDisabled, isFocused }) => {
        return {
            ...styles,
            backgroundColor: isFocused ? "#556ee6" : "#f8f9fa",
            color: isFocused ? "#fff" : "#495057",
            cursor: isDisabled ? "not-allowed" : "default",
            padding: "3px 10px",
        }
    },
    control: (styles, { isDisabled }) => {
        const updatedStyles = {
            ...styles,
            border: "1px solid #f46a6a",
            minHeight: "28px",
            padding: "3px 10px",
            fontSize: "12px",
        }
        return updatedStyles
    },
}
const CreateMakingModel = ({ modal, toggle, MakingListApi, isEdit, editData }) => {
    const { deleteApi, getApi, postApi, putApi } = useApi()
    const [formSumitLoading, setformSumitLoading] = useState(false)
    const [date, setdate] = useState(editData ? dateFormat(
        editData?.Date.split("T")[0],
        "dd-MM-yyyy"
    ) : dateFormat(
        new Date(),
        "dd-MM-yyyy"
    ))

    useEffect(() => {
        if (isEdit) {
            setdate(editData ? dateFormat(
                editData?.Date.split("T")[0],
                "dd-MM-yyyy"
            ) : dateFormat(
                new Date(),
                "dd-MM-yyyy"
            ))
        }
    }, [editData])


    // parcel Validations
    const validation = useFormik({
        enableReinitialize: true,
        initialValues: {
            OrderNo: editData ? editData.OrderNo : '',
            Name: editData ? editData.Name : '',
            Remark: editData ? editData.Remark : '',
        },
        validationSchema: Yup.object({
            OrderNo: Yup.string().required("The order no is required"),
            Name: Yup.string().required("The name is required"),
            Remark: Yup.string().required("The remark is required"),
        }),
        onSubmit: values => {
            setformSumitLoading(true)
            if (values) {

                isEdit ?
                    putApi("Making/update", {
                        Id: editData.Id,
                        OrderNo: values.OrderNo,
                        Name: values.Name,
                        Date: formatDateToISO(date),
                        Remark: values.Remark,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (MakingListApi != '') {
                                MakingListApi()
                            }
                            setdate(new Date())
                            validation.handleReset()
                        }
                    })
                    :

                    postApi("Making/create", {
                        OrderNo: values.OrderNo,
                        Name: values.Name,
                        Date: formatDateToISO(date),
                        Remark: values.Remark,
                    }).then(({ data, status }) => {
                        setformSumitLoading(false)
                        if (status == 400) {
                            toast.error(data, {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                        } else {
                            toast.success("Sucessfully created", {
                                style: {
                                    fontSize: "15px",
                                },
                            })
                            toggle()
                            if (MakingListApi != '') {
                                MakingListApi()
                            }
                            setdate(new Date())
                            validation.handleReset()
                        }
                    })
            }
        },
    })

    const [isMobile, setisMobile] = useState(window.innerWidth < 924)

    return (
        <Modal
            isOpen={modal}
            toggle={toggle}
            centered={true}
            size="xl"
            style={{ width: !isMobile ? "500px" : "" }}
        >
            <div className="modal-content">
                <ModalHeader toggle={toggle} tag="h5">
                    {isEdit ? "Update Making" : "Create Making"}
                </ModalHeader>
                <ModalBody>
                    <Form
                        onSubmit={e => {
                            e.preventDefault()
                            validation.handleSubmit()
                            return false
                        }}
                        onReset={e => {
                            e.preventDefault
                            validation.handleReset()
                            return false
                        }}
                    >
                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-2">
                                    <Label
                                        htmlFor="validationCustom03"
                                        className="required"
                                    >
                                        Order No.
                                    </Label>
                                    <Input
                                        name="OrderNo"
                                        placeholder="Oreder No"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.OrderNo}
                                        invalid={
                                            validation.touched.OrderNo && validation.errors.OrderNo
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.OrderNo && validation.errors.OrderNo ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.OrderNo}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={8}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Name
                                    </Label>
                                    <Input
                                        name="Name"
                                        placeholder="Name"
                                        type="text"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Name}
                                        invalid={
                                            validation.touched.Name && validation.errors.Name
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Name && validation.errors.Name ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Name}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                            <Col md={4}>
                                <FormGroup className="mb-2">
                                    <div>
                                        <Label htmlFor="FollowupValidation1Custom01" className="required">
                                            Date
                                        </Label>
                                        <div className="d-flex date-after" >
                                            <Flatpickr
                                                className="form-control d-block flatpicker-date"
                                                placeholder="dd-MM-yyyy"
                                                options={{
                                                    // enableTime: true,
                                                    dateFormat: "d-m-Y",
                                                    disableMobile: true
                                                }}
                                                value={date}
                                                onChange={(e) => { setdate(e) }}
                                            />
                                        </div>
                                    </div>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md={12}>
                                <FormGroup className="mb-2">
                                    <Label htmlFor="validationCustom03" className="required">
                                        Remark
                                    </Label>
                                    <Input
                                        name="Remark"
                                        placeholder="Enetr Remark "
                                        type="textarea"
                                        className="form-control-sm"
                                        onChange={validation.handleChange}
                                        onBlur={validation.handleBlur}
                                        value={validation.values.Remark}
                                        invalid={
                                            validation.touched.Remark && validation.errors.Remark
                                                ? true
                                                : false
                                        }
                                    />
                                    {validation.touched.Remark && validation.errors.Remark ? (
                                        <FormFeedback type="invalid">
                                            {validation.errors.Remark}
                                        </FormFeedback>
                                    ) : null}
                                </FormGroup>
                            </Col>
                        </Row>


                        <div className="text-end">
                            <Button
                                task-title="secondary"
                                className="btn btn-primary me-2 btn-sm "
                                type="reset"
                                color="secondary"
                            >
                                Reset
                            </Button>
                            {formSumitLoading ? (
                                <button
                                    type="button"
                                    className="btn btn-primary btn-sm"
                                >
                                    <i className="bx bx-hourglass bx-spin font-size-16 align-middle me-2"></i>
                                    Loading
                                </button>
                            ) : (
                                <Button
                                    color="primary"
                                    task-title="primary"
                                    className="btn btn-primary btn-sm "
                                    type="submit"
                                >
                                    Submit
                                </Button>
                            )}
                        </div>
                    </Form>
                </ModalBody>
            </div>
        </Modal>
    )
}

export default CreateMakingModel